<template>
    <div>
        <!-- display buttons for item details page here -->
        <div v-if="pageName == 'ItemDetails'" class="row">
            <div class="col-sm-6 col-12">
                <div class="row">
                    <div class="col-6">
                        <app-add-to-cart :item="item" class="form-control btn btn-dark-green listing-item-btns"></app-add-to-cart>
                    </div>
                    <div class="col-6">
                        <template v-if="itemSavedStatus">
                            <app-unsave-for-later :itemId="item._id" @emitItemSavedChecker="itemSavedChecker" class="form-control btn btn-outline-dark listing-item-btns"></app-unsave-for-later>
                        </template>
                        <template v-else>
                            <app-save-for-later :itemId="item._id" @emitItemSavedChecker="itemSavedChecker" class="form-control btn btn-outline-dark listing-item-btns"></app-save-for-later>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <!-- display buttons for items displayed from users shopping cart -->
        <div v-else-if="pageName == 'CartItem'" class="row">
            <div class="col-12">
                <div class="row my-1">
                    <div class="col-6 pr-1">
                        <app-remove-from-cart :itemId="item._id" class="form-control btn btn-outline-danger anewitem-items-btn p-0 py-1"></app-remove-from-cart>
                    </div>
                    <div class="col-6 pl-1">
                        <template v-if="itemSavedStatus">
                            <app-unsave-for-later :itemId="item._id" @emitItemSavedChecker="itemSavedChecker" class="form-control btn btn-outline-dark anewitem-items-btn p-0 py-1"></app-unsave-for-later>
                        </template>
                        <template v-else>
                            <app-save-for-later :itemId="item._id" @emitItemSavedChecker="itemSavedChecker" class="form-control btn btn-outline-dark anewitem-items-btn p-0 py-1"></app-save-for-later>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- display buttons for item results page for category and search results page here -->
        <div v-else class="row">
            <div class="col-md-12 col-sm-8 col-12">
                <div class="row my-1">
                    <div class="col-6 pr-1">
                        <app-add-to-cart :item="item" class="form-control btn btn-dark-green anewitem-items-btn p-0 py-1"></app-add-to-cart>
                    </div>
                    <div class="col-6 pl-1">
                        <template v-if="itemSavedStatus">
                            <app-unsave-for-later :itemId="item._id" @emitItemSavedChecker="itemSavedChecker" class="form-control btn btn-outline-dark anewitem-items-btn p-0 py-1"></app-unsave-for-later>
                        </template>
                        <template v-else>
                            <app-save-for-later :itemId="item._id" @emitItemSavedChecker="itemSavedChecker" class="form-control btn btn-outline-dark anewitem-items-btn p-0 py-1"></app-save-for-later>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { itemSavedCheckerFxn } from '@/store/dry'
import AddToCart from '@/components/general/shared/ItemParts/AddToCart.vue'
import RemoveFromCart from '@/components/general/shared/ItemParts/RemoveFromCart.vue'
import SaveForLater from '@/components/general/shared/ItemParts/SaveForLater.vue'
import UnsaveForLater from '@/components/general/shared/ItemParts/UnsaveForLater.vue'

export default {
    name: 'ItemActionBtns',
    props: {
        pageName: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            itemSavedStatus: false
        }
    },
    methods: {
        itemSavedChecker(theItemId) {
            return this.itemSavedStatus = itemSavedCheckerFxn(theItemId)
        }
    },
    components: {
        appAddToCart: AddToCart,
        appRemoveFromCart: RemoveFromCart,
        appSaveForLater: SaveForLater,
        appUnsaveForLater: UnsaveForLater
    },
    watch: {
        item() {
            this.itemSavedChecker(this.item._id)
        }
    },
    created() {
        this.itemSavedChecker(this.item._id)
    }
}
</script>
